module.exports = {"welcome":"Ihr Willkommensbonus erwartet Sie","more_info":"Mehr Info","select_bonus":"siehe Angebote","skip_bonus":"Überspringen (kein Bonus)","reward":"Loading...","bonus_code_input_placeholder":"Bonus Code eingeben","bonus_code_input_title":"Bonus Code","more_bonuses":"Weitere Boni"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/bonuses.json
// module id = 476
// module chunks = 248 1703